import React, { Fragment, useState } from "react";
import truck from "asset/images/truckIcon.svg";
import ship from "asset/images/shipIcon.svg";
import Modal from "react-bootstrap/Modal";
import { CloseIcon } from "asset/icons";
import { useNavigate } from "react-router-dom";
import Loader from "component/loader";

const AcceptShipmentModal = ({
    show,
    setShow,
    shipmentId,
    handleReceiverRejectOrAcceptShipment,
    shipmentLegs,
    isLoading
}) => {
    const navigate = useNavigate();
    const [note, setNote] = useState("");
    const [step, setStep] = useState(0);
    const goTo = (shipmentId) => {
        navigate(`/flex/home/manage-shipment?shipmentId=${shipmentId}`);
    };
    const currentLeg = shipmentLegs?.[step];
    const isTrucker = currentLeg?.type.toLowerCase() === "truck";

    const handleNext = async () => {
        if (step < shipmentLegs.length - 1) {
            setStep(step + 1);
        }
    };
    const handlePrev = () => {
        if (step > 0) {
            setStep(step - 1);
        } else {
            setStep(shipmentLegs.length - 1);
        }
    };
    const handleSelect = (index) => {
        setStep(index);
    };
    const handleClose = () => {
        setShow(false);
        setStep(0);
    };

    return (
        <Modal show={show} contentClassName="!rounded-xl w-full max-w-[503px] mx-auto" centered>
            <div className="flex items-start justify-between p-3">
                <div className="flex items-center gap-x-2">
                    <div className="flex flex-col text-left">
                        <h5>Accept {isTrucker ? "trucking" : "clearing"} request</h5>
                    </div>
                </div>
                <div className="flex items-start justify-center">
                    <CloseIcon
                        onClick={() => handleClose()}
                        className="!size-4 cursor-pointer text-[#667085] fill-[#667085] stroke-[#667085]"
                    />
                </div>
            </div>
            <section className="px-3 pb-3">
                <p className="font-medium text-sm text-gray-40 !mb-2">
                    {isTrucker ? "Trucking" : "Clearance"} details
                </p>
                <div className="border rounded-lg border-light-grey">
                    <div className="p-2 border-b">
                        <p className="pb-2 text-sm ">{isTrucker ? "Trucking" : "Clearing"} fee</p>
                        <p className="!text-lg font-medium !text-left">$40</p>
                    </div>
                    <div className="p-2 border-t">
                        <div className="flex space-x-3">
                            <div className="flex flex-col items-center">
                                <div className="flex items-center justify-center rounded-full size-5">
                                    {currentLeg?.type.toLowerCase() === "truck" ? (
                                        <img src={truck} alt="Truck Logo" className="size-3" />
                                    ) : (
                                        <img src={ship} alt="Truck Logo" className="size-3" />
                                    )}
                                </div>
                                <div className="w-[2px] h-8 bg-gray-300"></div>
                            </div>

                            <div className="pb-2">
                                <p className="text-sm text-gray-500">
                                    {currentLeg?.type.toLowerCase() === "truck"
                                        ? "Pick-up from"
                                        : "Departure Port"}
                                </p>
                                <p className="text-xs font-semibold text-gray-500">
                                    {currentLeg?.departurePort?.address}
                                </p>
                            </div>
                        </div>
                        <div className="flex space-x-3">
                            <div className="flex flex-col items-center">
                                <div className="flex items-center justify-center rounded-full size-5">
                                    {currentLeg?.type.toLowerCase() === "truck" ? (
                                        <img src={truck} alt="Truck Logo" className="size-3" />
                                    ) : (
                                        <img src={ship} alt="Truck Logo" className="size-3" />
                                    )}
                                </div>
                            </div>

                            <div className="pb-2">
                                <p className="text-sm text-gray-500">
                                    {currentLeg?.type.toLowerCase() === "truck"
                                        ? "Drop-off Point"
                                        : "Destination Port"}
                                </p>
                                <p className="text-xs font-semibold text-gray-500">
                                    {currentLeg?.destinationPort?.address}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* The footer section */}
            <footer className="flex items-center justify-between p-3 pt-2 space-y-1 border-t">
                <div className="flex items-start justify-between gap-x-2">
                    {shipmentLegs?.map((item, index) => (
                        <div
                            onClick={() => handleSelect(index)}
                            key={index + item?._id}
                            className={`w-7 rounded-sm h-3  cursor-pointer ${
                                step === index ? "!bg-secondary" : "!bg-[#EBE4FF]"
                            }`}
                        ></div>
                    ))}
                </div>

                <div className="flex items-center justify-between gap-x-2">
                    <button
                        onClick={() => (step > 0 ? handlePrev() : handleClose())}
                        className="flex px-4 py-2 bg-transparent rounded-lg text-main-dark gap-x-2"
                    >
                        {step > 0 ? "Back" : "Cancel"}
                    </button>
                    <button
                        className={`w-auto flex px-4 py-2 text-base rounded-lg items-center justify-center border-none outline-none text-white !bg-secondary`}
                        type="button"
                        onClick={() => {
                            if (step === shipmentLegs.length - 1) {
                                handleReceiverRejectOrAcceptShipment({
                                    shipmentId,
                                    status: "accepted",
                                });
                            } else {
                                handleNext();
                            }
                        }}
                    >
                        {isLoading ? <Loader /> : " Accept request"}
                    </button>
                </div>
            </footer>
        </Modal>
    );
};

export default AcceptShipmentModal;
